import { addDays, addHours, format, startOfWeek } from 'date-fns';
import { ISSRPeriod } from '../model/weekSchedule';

// As semanas do cronograma vão de segunda a domingo.
// O start pode chegar como ISO em UTC (vindo da API), então aplicamos o
// deslocamento de 3h usado no restante do módulo antes de ancorar na segunda,
// garantindo que o título do SSR englobe a semana inteira.
export const getSSRWeekPeriod = (weekStart: Date | string): ISSRPeriod => {
  const monday = startOfWeek(addHours(new Date(weekStart), 3), { weekStartsOn: 1 });
  const sunday = addDays(monday, 6);

  return {
    startDate: format(monday, 'yyyy-MM-dd'),
    endDate: format(sunday, 'yyyy-MM-dd'),
  };
};
